export default __webpack_public_path__ + "static/media/ReadMoreGreen.71615d95.svg";